import { validEmail, validPhone } from 'js/util/util.js'
import Cookie from 'js/lib/cookie.js'

const { postData } = require('js/api/getdata').default

const TIMESTHRESHOLD = 10 // 可校验的次数
const COUNTDOWN = 60 // 验证码倒计时
const TIPMAP = {
  pending: {
    message: '发送中...',
    color: '#4C5365',
  },
  max: {
    message: '您今天验证次数过多，请明天或换个手机号试试',
    color: '#FF3D3C',
  },
  200: {
    message: '验证码已发送至手机',
    color: '#4C5365',
  },
  '40X': {
    message: '验证码发送失败，请重试',
    color: '#FF3D3C',
  },
  '50X': {
    message: '验证码发送失败，请重试',
    color: '#FF3D3C',
  },
  else: {
    message: '',
  },
  invalid: {
    message: '请输入正确的邮箱或手机号格式',
    color: '#FF3D3C',
  },
  poorNetwork: {
    message: '网络错误，请重试',
    color: '#FF3D3C',
  },
}
const statusMap = {
  start: {
    txt: '获取验证码',
  },
  next: {
    txt: `重新发送(${COUNTDOWN})`,
  },
}
const getCaptcha = {
  data() {
    return {
      times: 0, // 统计发送了多少次验证码
      countdown: COUNTDOWN, // 验证码倒计时
      isPending: false, // 验证码发送中...
      interval: null, // 用于倒计时的setinterval
      emobileCnTip: '', // email&mobile 错误提示信息
      getCaptchaTip: '', // 获取验证码的提示信息
      captchaPatten: '', // 记录当前阶段，通过它改变button的css
      inputDisabled: false, // 是否diabled掉input框
      isEmailCheck: false, // 是验证的是邮箱，提示语会不同
    }
  },
  methods: {
    /**
         * 发送验证码前的校验
         * @params {String} checkString 手机号或邮箱
         */
    preVerify(checkString, countryCode, verifyFunc) {
      // 从cookie获取当前手机号的验证次数，未来通过接口获取
      this.times = this.getCookie(`+${countryCode}-${checkString}`, (val) => {
        const value = +val
        if (isNaN(value)) {
          return 0
        }
        return value
      })
      // 进行自定义校验
      if (typeof verifyFunc === 'function') {
        if (!verifyFunc(checkString)) {
          return false
        }
      }
      // 进行默认的手机或email校验
      if (!verifyFunc && !validEmail(checkString) && !validPhone(checkString)) {
        this.getCaptchaRes('invalid')
        return false
      }
      if (this.isPending) return false // 发送中...
      if (this.times >= TIMESTHRESHOLD) { // 发送次数超过最大数
        this.getCaptchaRes('max')
        this.changeSatus('start')
        this.captchaPatten = 'disable-captcha'
        this.inputDisabled = true
        return false
      }
      if (this.countdown < COUNTDOWN && this.countdown > 0) return false // 验证码倒计时中
      this.isEmailCheck = checkString.indexOf('@') > -1
      return true
    },
    /**
         * 发送验证码
         * @params {String} checkString 手机号或邮箱
         * @params {String} countryCode 国际区号，默认为中国86
         * @params {Object} 发送验证码所需的参数
         * @params {Function} verifyFunc 自定义的校验方法
         */
    getCaptcha(checkString, countryCode = '86', authData = {}, verifyFunc) {
      if (this.preVerify(checkString, countryCode, verifyFunc)) {
        const vm = this
        if (JSON.stringify(authData) == '{}') {
          console.log('please provide request params of get captcha')
          return
        }
        this.captchaPatten = 'disable-captcha'
        this.isPending = true // 验证码发送中...
        this.changeSubmitStatus()
        this.changeSatus('next')
        // 模拟发送
        // setTimeout(() => {
        //     this.isPending = false;
        //     this.times++
        //     this.changeSubmitStatus();
        //     this.countLeft();
        //     console.log('times=', this.times)
        //     vm.setCookie(`+${countryCode}-${checkString}`, this.times)
        //     this.getCaptchaRes(200, {
        //         message: this.$t(`验证码已发送至手机，您还能发送{n}次验证码`, {'n': TIMESTHRESHOLD - this.times}),
        //         color: '#4C5365',
        //     })
        // }, 2000)
        postData('getSmCaptcha', authData).then((res) => {
          vm.isPending = false
          vm.times++
          vm.changeSubmitStatus()
          vm.countLeft()
          vm.setCookie(`+${countryCode}-${checkString}`, this.times)
          vm.getCaptchaRes(200, {
            message: vm.$t('验证码已发送至手机，您还能发送{n}次验证码', { n: TIMESTHRESHOLD - this.times }),
            color: '#4C5365',
          })
        }).catch((err) => {
          if (err.response) {
            const error = err.response.status
            const code = error.toString().indexOf('50') >= 0 ? '50X' : error.toString().indexOf('40') >= 0 ? '40X' : ''
            vm.getCaptchaRes(code)
            vm.changeSatus('start')
          } else {
            vm.getCaptchaRes('poorNetwork')
            vm.changeSatus('start')
          }
          vm.isPending = false
          vm.changeSubmitStatus()
          vm.captchaPatten = ''
        })
      }
    },
    getCookie(name, func) {
      const val = Cookie.get(name)
      if (typeof func === 'function') {
        return func(val)
      }
      return val || ''
    },
    setCookie(name, value) {
      const today = new Date()
      today.setDate(today.getDate() + 1)
      today.setHours(0, 0, 0, 0)
      const endToday = new Date(today.getTime())
      const options = {
        expires: endToday,
      }
      Cookie.set(name, value, options)
    },
    /**
         * 倒计时
         */
    countLeft() {
      const vm = this
      if (!vm.interval) {
        vm.interval = setInterval(() => {
          vm.countdown--
          vm.changeSatus('next')
          if (vm.countdown === 1) {
            setTimeout(() => {
              clearInterval(vm.interval)
              vm.interval = null
              vm.countdown = COUNTDOWN
              vm.changeSatus('start')
              this.captchaPatten = ''
            }, 1000)
          }
        }, 1000)
      }
    },
    stopProcess() {
      const vm = this
      if (vm.interval) {
        this.countdown = COUNTDOWN // 重置倒计时
        clearInterval(vm.interval)
        vm.interval = null
      }
    },
    /**
         * 改变发送按钮
         * @param {String} 根据code来显示不同的展示文字
         */
    changeSatus(code) {
      if (code === 'next') {
        statusMap[code].txt = `${this.$t('重新发送')}(${this.countdown})`
      }
      if (statusMap[code]) {
        this.captchaButTxt = statusMap[code].txt || ''
      } else {
        this.captchaButTxt = ''
      }
    },
    /**
         * 改变提交按钮状态
         */
    changeSubmitStatus() {
      if (this.isPending) {
        this.submitTxt = '发送中...'
        this.getCaptchaTip = ''
        this.sucCaptchaIcon = false
      } else {
        this.submitTxt = '提交'
      }
    },
    /**
         * 显示提示语
         * @param {String} code 根据code来显示不同提示语
         * @param {Object} resTip 自定义提示语
         */
    getCaptchaRes(code = 'else', resTip) {
      this.sucCaptchaIcon = false
      if (code == 'invalid') {
        this.emobileCnTip = (TIPMAP[code] && TIPMAP[code].message) || ''
        return
      }
      if (code == '200' && TIMESTHRESHOLD - this.times <= 3) {
        this.sucCaptchaIcon = true
        this.getCaptchaTip = resTip.message || ''
        return
      }
      if (code == '200' && TIMESTHRESHOLD - this.times > 3) {
        this.sucCaptchaIcon = true
        if (this.isEmailCheck) {
          this.getCaptchaTip = '验证码已发送至邮箱'
          return
        }
      }
      this.getCaptchaTip = TIPMAP[code].message || ''
    },

  },

}
export { getCaptcha }
